<template>
  <div>
    <div class="g-container">
      <!--活动-->
      <a :href="ActivityPcUrl" target="_blank">
        <div class="across" v-show="activity">
          <div class="across_D">
            <i class="tan2"></i>
            <div class="detail_font">
              <span class="font1">高环保水性EAU复合树脂彩色路面专家</span><br />
              <span class="font2">寻找战略合作伙伴</span><br />
              <span class="font3">区域保护 共赢共享</span>
            </div>
            <i class="out1" v-on:click.self.prevent="activitys"></i>
          </div>
        </div>
      </a>
      <!--活动弹窗-->
      <div class="tan5s" v-if="popup5s">
        <i class="out" @click="popup5s = false"></i>
        <a :href="ActivityPcUrl" target="_blank"><i class="tan1"></i></a>
      </div>
      <i class="bgm" v-show="isactivity"></i>

      <div
        class="m-container m-width"
        :style="{ top: isactivity ? '-430px' : '0' }"
      >
        <!--面包屑-->
        <div class="crumbs-box" v-if="isactivity == false">
          <router-link tag="a" class="c-crumbs" :to="{ name: 'mallIndex' }"
            >云商城</router-link
          >
          <span class="c-sep">&gt;&gt;</span>
          <!--{{detail.title}} -->
          <span class="c-current">产品名称</span>
        </div>
        <!--商品详情-->
        <div class="qiu" v-show="isactivity">
          <i class="qiu3"></i>
          <i class="qiu2"></i>
          <i class="qiu1"></i>
        </div>
        <div class="crumbs_xs">
          <div class="preview-hd">
            <div class="preview-picture">
              <div class="preview-pic">
                <img
                  class="close"
                  @click="shipi = false"
                  v-if="shipi == false && activeImg == ''"
                  :src="image[0]"
                />
                <div
                  class="shipibof_img"
                  @click="shipi = true"
                  v-show="!shipi"
                  v-if="good.VideoPath"
                >
                  <i class="shipibof"
                    ><span class="shipibof_font">视频&gt;</span></i
                  >
                </div>
                <iframe
                  :src="good.VideoPath"
                  frameborder="0"
                  allow="autoplay;encrypted-media"
                  style="width: 100%; height: 100%"
                  v-if="shipi"
                ></iframe>
                <img v-image-preview :src="activeImg" alt="" v-else />
                <!--显示+show-->
                <div class="zoom-icon"></div>
              </div>
              <div class="preview-large-pic">
                <!--<img src="../../../../html/pages/home/images/demo.png" alt="" />-->
              </div>
              <!--滑动小图-->
              <div class="pre-small-swiper">
                <swiper :options="swiperOption" ref="mySwiper">
                  <swiper-slide v-for="(item, index) in image" :key="index">
                    <a class="oper-pic" href="javascript:;">
                      <!--:src="item"-->

                      <img :src="item" @click="chooseImg(item, index)" />
                    </a>
                  </swiper-slide>
                </swiper>
                <div
                  class="swiper-button-prev swiper-button-black"
                  slot="button-prev"
                ></div>
                <div
                  class="swiper-button-next swiper-button-black"
                  slot="button-next"
                ></div>
                <!--  <div class="cover-prev"></div>
                                <div class="cover-next"></div>-->
              </div>
            </div>
            <div class="preview-hd-info">
              <b class="goods-title">{{ good.Name }}</b>
              <div style="padding: 15px 22px 10px 0">
                <div class="brand">
                  <span class="mouth"> 口碑 </span>
                  <i class="xin"></i>
                  <span class="fonthover">
                    <span class="risk">险</span>
                    <span class="fontblock riskblock">PICC承保产品责任</span>
                  </span>
                  <span class="fonthover">
                    <span class="recognize">认</span>
                    <span class="fontblock recognizeblock"
                      >国际田联（IAAF）跑道认证、SGS国际认证、RoHS欧盟环境及健康认证、CE欧盟安全认证</span
                    >
                  </span>
                </div>
              </div>
              <div class="goods-price">
                <span style="position: relative">
                  <i class="iii" v-if="isactivity"></i>
                  <span class="c-label">零售价：</span>
                  <span class="c-price"
                    >￥<span style="font-size: 24px; font-weight: 600">{{
                      good.Price
                    }}</span></span
                  >
                </span>
                <span style="margin-left: 50px" v-if="isactivity">
                  <span class="c-label">活动价：</span>
                  <span class="c-price"
                    >￥<span style="font-size: 24px; font-weight: 600">{{
                      good.ActivityPrice
                    }}</span></span
                  >
                </span>
                <span v-if="ActivityEndTime">
                  <span class="a66"
                    >距活动结束：
                    <span class="aoo" v-for="txt in day">{{ txt }}</span>
                    <span class="matime">天</span>
                    <span class="aoo" v-for="txt in hours">{{ txt }}</span>
                    <span class="matime">时</span>
                    <span class="aoo" v-for="txt in minutes">{{ txt }}</span>
                    <span class="matime">分</span>
                  </span>
                </span>
              </div>
              <div class="goods-classify">
                <div class="classify-label">分类</div>
                <div class="classify-col">
                  <div
                    v-for="(item, index) in ModelList"
                    :key="index"
                    :class="index == current ? 'seen' : 'c-cols'"
                    @click="detailIndex(index)"
                    @mouseenter="videoPlayback(item, index)"
                    @mouseleave="videoStopped"
                    :style="{
                      border:
                        seens == index || index == current
                          ? ''
                          : '1px solid #B8B7BD',
                    }"
                  >
                    {{ item }}
                    <div
                      :id="'tithover' + index"
                      :class="hovernum == index ? 'block' : 'none'"
                    >
                      {{ good.Descrption }}
                    </div>
                  </div>
                </div>
              </div>
              <!---->
              <div style="">
                <div
                  class="goods-classify"
                  style="display: flex; padding: 11px 0 15px 0"
                >
                  <div class="classify-img">电话咨询</div>
                  <div class="classify">
                    <b>{{ good.Phone }}</b>
                  </div>
                </div>
                <div class="bor_bot">
                  <div class="add-cart-btn" @click="outer">
                    <i class="icon"></i>
                    咨询问价
                  </div>
                  <div type="text" class="baghuang">
                    <i class="cart-icon"></i>
                    <label class="yi_kan"
                      >已有<span class="num_y">{{ good.AdvisoryCount }}</span
                      >人咨询</label
                    >
                  </div>
                </div>
                <div class="dis_flx">
                  <div>其他</div>
                  <div class="top_tao" @click="gotoTaobao">
                    <i class="car"></i>
                    <span>去淘宝购买</span>
                  </div>
                  <div class="top_2">
                    <div
                      class="hover_wei"
                      @mouseenter="onMousteIn()"
                      @mouseleave="onMousteOut()"
                    >
                      <span>微信咨询 </span>
                      <i class="wei" v-if="good.QRCode"></i>
                      <i class="xia" v-if="good.QRCode"></i>
                      <img
                        class="shang"
                        :src="good.QRCode"
                        v-if="hoverWei == true && good.QRCode"
                      />
                      <i v-if="!good.QRCode" style="font-size: 13px"
                        >该产品还未上传客服二维码</i
                      >
                    </div>
                  </div>
                </div>

                <!--<div class="floRight" v-if="weixinImg">
                                    <div class="  text-center ">
                                        <img :src="weixinImg" alt="" class="cart">
                                    </div>
                                    <div class="weixin">加微信咨询</div>
                                </div>-->
              </div>
              <!--咨询-预约弹窗-->
              <el-dialog title="立即免费预约厂家" :visible.sync="outerVisible">
                <div class="open_input">
                  <input
                    v-model="phone"
                    @change="tel"
                    type="text"
                    placeholder="请输入您的手机号，厂家会尽快联系到您"
                    :id="oInputId ? 'redInput' : 'oInput'"
                  />
                  <span v-if="oInputId" class="tishi">请输入正确的手机号</span>
                </div>
                <el-dialog
                  width="30%"
                  title="成功预约，等待联系"
                  :visible.sync="innerVisible"
                  append-to-body
                >
                  <div class="cg_img">
                    <i class="cg"></i>
                  </div>
                  <div class="changjia">
                    厂家已接收到您的预约信息，稍后就会拨打您电话，请保持电话畅通!
                  </div>
                </el-dialog>
                <div slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="open">立即预约</el-button>
                </div>
              </el-dialog>
            </div>
          </div>
        </div>

        <!--产品工艺-->
        <div class="mall-preview" style="height: 262px" v-if="scheme">
          <div class="shop_tit margin30 paddingtop26">
            <i class="shop_gyi"></i>
            <div class="shop_tit deta_tit">产品工艺</div>
          </div>
          <div class="disflxed">
            <div v-for="(txt, index) in scheme.Videos" class="video-area">
              <i class="bofang" @click="openPopVideo(txt.VideoUrl)"></i>
              <video class="area">
                <source
                  autoplay="autoplay"
                  :src="txt.VideoUrl"
                  type="video/mp4"
                />
              </video>
              <span class="font_video">{{ txt.Title }}</span>
            </div>
            <div style="cursor: pointer" @click="gotocloud(scheme.Id)">
              <i class="taihu" :class="url"></i>

              <div class="maska">
                <span class="font_gyi">浏览完整的工艺及图文说明</span>
              </div>
            </div>
          </div>
        </div>

        <!--视频弹框 显示 +show-->
        <div class="shadow-fixed show" v-show="popVideoDir">
          <div class="mask">
            <div class="mask_top">
              <div class="bomb-small-close" @click="closePopVideo"></div>
              <div class="bomb-video-box">
                <video
                  style="width: 100%; height: 100%"
                  ref="popVideo"
                  class="video-area"
                  autoplay
                  controls="true"
                ></video>
                <!--播放按钮 显示 +show-->
                <i class="video-icon"></i>
              </div>
            </div>
          </div>
        </div>
        <!--走马灯 -->
        <div class="mall-preview" v-if="cases.length != 0 && !isactivity">
          <div class="goods-preview he392">
            <div class="shop_tit margin30">
              <i class="fan_img"></i>
              <div class="shop_tit deta_tit">产品案例</div>
            </div>
            <div class="goods-preview-inner">
              <!--    <el-carousel indicator-position="outside">
                                <el-carousel-item  v-for="(item,subindex) in cases" :key="subindex" class='aaaa'>
                                    <div v-for="(imgitem,indicatorIndex) in item" :key='indicatorIndex' class="flxd maLeft18">
                                        <a href="" class="case-item" target="_blank">
                                            <div class="case-pic">
                                                <img class="tu"  alt="" :src="imgitem.bgImg">
                                                <div class="tag"><span v-for='(sub,typeIndex) in imgitem.tags' class=" tag_left">{{sub}}</span></div>
                                            </div>
                                            <div class="case-handle">
                                                <b class="tag-view">{{imgitem.Title}}</b>
                                                <div>
                                                    <span>项目周期：{{imgitem.cycle}}</span>
                                                    <i class="star-icon five-star"></i>
                                                </div>
                                                
                                            </div>
                                            <div class="case-describe">{{imgitem.Desc}}</div>                                
                                        </a>
                                    </div>
                                
                                </el-carousel-item>
                                <div class="box_"></div>
                            </el-carousel>-->
              <!--在此处添加渲染的内容-->
              <div class="swiper-box" style="position: relative">
                <div
                  class="box_"
                  style="right: -66px"
                  v-if="cases.length >= 4"
                ></div>
                <div
                  class="swiper-button-prev1 swiper-button-black"
                  slot="button-next"
                ></div>
                <swiper
                  :options="swiperOption2"
                  class="swiper"
                  style="position: relative; top: -40px; margin: 0 3px 0 19px"
                >
                  <swiper-slide
                    class="swiper-slide"
                    v-for="(item, index, key) in cases"
                    :key="key"
                  >
                    <a @click="goto(item.Id)" class="case-item" target="_blank">
                      <div class="item-img case-pic" width="100%" height="100%">
                        <img
                          class="tu"
                          :src="item.bgImg"
                          alt=""
                          width="100%"
                          height="100%"
                        />
                        <div class="tag">
                          <span
                            v-for="(sub, typeIndex) in item.tags"
                            class="tag_left"
                            >{{ sub }}</span
                          >
                        </div>
                      </div>
                      <div class="case-handle">
                        <b class="tag-view">{{ item.Title }}</b>
                        <div>
                          <span class="zhouqi">项目周期：{{ item.cycle }}</span
                          ><i class="star-icon five-star"></i>
                        </div>
                      </div>
                      <div class="case-describe">{{ item.Desc }}</div>
                    </a>
                  </swiper-slide>
                </swiper>
                <div
                  class="swiper-button-next1 swiper-button-black"
                  slot="button-prev"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <!--产品详情 -->
        <div class="mall-preview910" id="mallBar">
          <div class="goods-preview he">
            <div class="shop_tit margin30">
              <i class="shop_leix"></i>
              <div class="shop_tit deta_tit">产品详情</div>
            </div>
            <div
              style="text-align: center; padding: 26px 30px; width: 850px"
              v-if="ProDetail"
            >
              <div v-for="(item, index) in ProDetail">
                <img
                  :style="{ width: item.type == 1 ? '846px' : '' }"
                  :src="item.pic"
                  alt=""
                  class="w100"
                />
              </div>
            </div>
            <div
              v-else
              style="
                text-align: center;
                width: 910px;
                margin-top: 30%;
                color: #4d4d4d;
              "
            >
              暂无详情
            </div>
          </div>
        </div>
        <!--资讯热线 -->
        <div
          class="mall-pre"
          id="searchBar"
          :class="searchBarFixed == true ? 'isFixed' : ''"
        >
          <div class="bapre">
            <div class="shop_tit">
              <div class="title">咨询热线</div>
            </div>
            <div class="shouji">
              <i class="rexian"></i>
              <span>{{ good.Phone }}</span>
            </div>
            <div class="maTop" v-if="weixinImg">
              <div class="title paLeft">微信联系</div>
              <div class="image" style="padding: 10px">
                <img class="qrcode_iduilv_2" :src="weixinImg" alt="" />
              </div>
            </div>
            <div class="maTop" style="margin-top: 10px">
              <div class="title paLeft maTop15">预约咨询</div>
              <div class="image_input">
                <input
                  type="text"
                  placeholder="请输入手机号码"
                  v-model="offerPhone"
                  :id="offerInput ? 'redoffer' : 'oInput'"
                />
                <span v-if="offerInput" class="offerred"
                  >请输入正确的手机号</span
                >
              </div>
            </div>
            <div class="btn" @click="offer">
              <input type="button" value="为我报价" />
            </div>
            <div class="zhuyi">
              注：预约后商家会尽快回电与您联系，请保证电话真实通畅
            </div>
          </div>
          <!-- <div class="weixing">
                        <div id="qrCode" ref="qrCodeDiv" ></div>
                        <div><span>扫一扫，手机浏览本产品</span></div>
                    </div>-->
        </div>
      </div>
    </div>
    <div style="height: 80px; background: #f5f7fa"></div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import "swiper/dist/css/swiper.css";

import "../../../../html/components/crumbs/crumbs.scss";
import "../../../../html/pages/mall/details/details.scss";
import "../../../../html/pages/mall/details/details.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

import { Details, Advisory } from "../../../../api/index.js";
export default {
  name: "detail",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      detail: {},
      activeImg: "",
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        //左右点击
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOption2: {
        speed: 600, //切换速度
        watchOverflow: true, //当没有足够的slide切换时，例如只有1个slide（非loop），swiper会失效且隐藏导航等。默认不开启这个功能。
        autoplay: true,
        slidesPerView: 4,
        spaceBetween: 100,
        preventClicksPropagation: true, //阻止click冒泡。拖动Swiper时阻止click事件。
        simulateTouch: true, //鼠标模拟手机触摸。默认为true，Swiper接受鼠标点击、拖动。
        navigation: {
          nextEl: ".swiper-button-next1", //前进按钮的css选择器或HTML元素。
          prevEl: ".swiper-button-prev1", //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: "my-button-disabled", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden", //按钮隐藏时的Class
        },
        pagination: {
          el: ".swiper-pagination",
        },
        on: {
          touchEnd: function (event) {
            //你的事件
          },
        },
      },
      current: 0,
      outerVisible: false,
      innerVisible: false,
      phone: "",
      oInputId: false,
      shipi: false,
      hovernum: -1,
      seens: -1,
      good: {},
      image: [],
      ModelList: [],
      casesData: [],
      cases: [],
      ProDetail: [],
      offerPhone: "",
      offerInput: false,
      weixinImg: "",
      offsetTop: 0,
      searchBarFixed: false,
      popVideoDir: false,
      scheme: {},
      url: "",
      hoverWei: false,
      activity: null,
      popup5s: false,
      isactivity: false,
      day: [],
      hours: [],
      minutes: [],
      ActivityEndTime: "",
      ActivityPcUrl: "",
    };
  },
  methods: {
    getTime() {
      if (this.ActivityEndTime) {
        var d = new Date(this.ActivityEndTime + " 00:00:00");
        d.setDate(d.getDate() + 1);
        let myDate = new Date().getTime();
        let time = d - myDate;
        this.day = Math.floor(time / (24 * 3600 * 1000));
        this.day = this.day < 10 ? "0" + this.day : this.day;
        this.day = this.day.toString();
        var leave1 = time % (24 * 3600 * 1000);
        var hours = Math.floor(leave1 / (3600 * 1000)); //计算时
        this.hours = (hours < 10 ? "0" + hours : hours).toString();
        var leave2 = time % (3600 * 1000);
        this.minutes = Math.ceil(leave2 / (60 * 1000));
        this.minutes = this.minutes < 10 ? "0" + this.minutes : this.minutes;
        this.minutes = this.minutes.toString();
      }
    },
    activitys() {
      this.activity = false;
      if (this.isactivity == false) {
        this.activity = false;
      } else if (this.isactivity == true && this.activity == false) {
        this.activity = false;
      }
      setTimeout(() => {
        this.popup5s = true;
      }, 5000);
    },
    //鼠标移进去
    videoPlayback(item, index) {
      this.hovernum = index;
      this.seens = index;
    },
    //鼠标离开
    videoStopped() {
      this.hovernum = -1;
      this.seens = -1;
    },
    onMousteIn() {
      this.hoverWei = true;
    },
    onMousteOut() {
      this.hoverWei = false;
    },
    gotocloud(Id) {
      let routeData = this.$router.resolve({
        name: "cloudDetail",
        params: { id: Id },
      });
      window.open(routeData.href, "_blank");
    },
    goto(id) {
      var href = "/pc/#/cases/detail/" + id;
      window.open(href, "_blank");
    },
    closePopVideo() {
      this.$refs.popVideo.pause();
      this.popVideoDir = false;
    },
    openPopVideo(vedio) {
      // this.currentVideo = '//www.iduilv.com' + vedio;
      // console.log(this.currentVideo);

      this.popVideoDir = true;
      this.$refs.popVideo.src = vedio;
      this.$refs.popVideo.play();
    },
    tel() {
      if (!/^1[345789]\d{9}$/.test(this.phone)) {
        // alert("请输入正确的手机号");
        this.oInputId = true;
        this.phone = "";
        return;
      } else {
        this.oInputId = false;
      }
    },
    async open() {
      if (this.phone || this.phone != "") {
        this.outerVisible = false;
        this.oInputId = false;
        let res = await Advisory({
          id: this.$route.params.id,
          phone: this.phone,
        });
        if (res.Type == "Success") {
          this.innerVisible = true;
        } else {
          alert(res.Content);
        }
      } else {
        this.oInputId = true;
      }
    },
    async offer() {
      if (!/^1[345789]\d{9}$/.test(this.offerPhone)) {
        this.offerInput = true;
        this.offerPhone = "";
        return;
      } else {
        this.offerInput = false;
      }

      if (this.offerPhone || this.offerPhone != "") {
        this.offerInput = false;
        let res = await Advisory({
          id: this.$route.params.id,
          phone: this.offerPhone,
        });
        alert(res.Content);
      } else {
        this.offerInput = true;
      }
    },
    outer() {
      this.outerVisible = true;
      this.oInputId = false;
      this.phone = "";
    },

    async Details() {
      let res = await Details({
        id: this.$route.params.id,
      });
      if (res.Type == "Success") {
        this.good = res.Data.good;
        this.image = this.good.PicPaths.split(",");
        this.ModelList = JSON.parse(this.good.ModelList);
        this.cases = res.Data.cases;
        this.scheme = res.Data.scheme;
        this.isactivity = res.Data.isActivity;
        this.ActivityEndTime = res.Data.ActivityEndTime;
        this.ActivityPcUrl = res.Data.ActivityPcUrl;
        if (this.isactivity == false) {
          this.activity = false;
        } else if (this.isactivity == true && this.activity == false) {
          this.activity = false;
        } else if (this.isactivity == true && this.activity == null) {
          this.activity = true;
        }
        // this.casesData = Math.ceil(data.length/4)
        this.weixinImg = this.good.QRCode;
        // var chunk = 4; //每4个分一组
        // for (var i = 0, j = data.length; i < j; i += chunk) {
        // this.cases.push(data.slice(i, i + chunk));
        // }
        this.ProDetail = JSON.parse(this.good.ProDetail);
        //二维码暂时隐藏 this.bindQRCode()
        this.getTime();
      } else {
        this.$layer.alert(res.Content);
      }
    },
    detailIndex(i) {
      this.current = i;
    },
    chooseImg(item, i) {
      this.activeImg = this.image[i];
      this.shipi = false;
    },

    gotoTaobao() {
      if (this.good.TaobaoUrl != null) {
        window.open(this.good.TaobaoUrl, "_blank");
      } else {
        window.open(this.good.taobaoUrl, "_blank");
      }
    },
    // 生成二维码
    bindQRCode() {
      var _this = this;
      new QRCode(_this.$refs.qrCodeDiv, {
        text:
          "https://www.iduilv.com/Api/Store/BindWeixin/?id=" +
          this.$route.params.id,
        width: 140,
        height: 140,
        colorDark: "#000", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        //   correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
      });
    },
    handleScroll() {
      if (this.offsetTop == 0) {
        this.offsetTop = document.querySelector("#searchBar").offsetTop;
      }
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      scrollTop > this.offsetTop
        ? (this.searchBarFixed = true)
        : (this.searchBarFixed = false);
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  created() {
    this.Details();
    var images = ["tu1", "tu2", "tu3", "tu4", "tu5"];
    this.url = images[Math.floor(Math.random() * images.length)];
    var _this = this;
    setTimeout(function () {
      window.addEventListener("scroll", _this.handleScroll);
    }, 50);
  },
  watch: {
    $route(to, from) {
      this.Details();
    },
    popup5s(val, oldVal) {
      if (val == false) {
        setTimeout(() => {
          this.popup5s = true;
        }, 5000);
      }
    },
  },
};
</script>

<style>
.matime {
  margin: 0 4px;
}
.a66 {
  color: #666666;
  font-size: 14px;
  float: right;
  position: relative;
  top: 8px;
}
.aoo {
  color: #fff;
  background: #ff5a00;
  font-size: 18px;
  padding: 1px 7.8px;
  margin: 0 2px;
  border-radius: 4px;
}
.box_ {
  box-shadow: -90px 0px 60px #545454;
}
.tag-view {
  color: #333;
  font-size: 15px;
}
.swiper-button-lock {
  display: inherit;
}
.zhouqi {
  width: 180px;
  display: -webkit-box;
  overflow: hidden;
  height: 36px;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.star-icon.five-star {
  float: right;
  margin-top: -23px;
  position: absolute;
  right: 0;
}
.w100 {
  width: 100%;
}
</style>
